import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

/**
 * Cel Web Share Target: Android przekazuje udostępniony tekst w `text`, a niektóre aplikacje w `title` lub `url`.
 * Składamy niepuste pola i przechodzimy do nowej listy.
 */
export function SharePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const values = ['title', 'text', 'url'].map((k) => params.get(k)?.trim() ?? '').filter(Boolean);
    // Część aplikacji powtarza ten sam tekst w kilku polach — pomijamy pole zawarte w innym.
    const parts = values.filter((v, i) => !values.some((w, j) => j !== i && w.includes(v) && (w !== v || j < i)));
    navigate('/new', { replace: true, state: { text: parts.join('\n') } });
  }, [params, navigate]);

  return <div className="p-8 text-center text-stone-500">Otwieram…</div>;
}
